import { connect } from 'react-redux';
import Testimonials from 'marketing/testimonials';

const mapStateToProps = ({ marketing }) => {
  return {
    stats: marketing.reviewStats
  };
}

export default connect(mapStateToProps)(Testimonials);



// WEBPACK FOOTER //
// ./marketing/containers/testimonials.js